export function InvestmentsBlock() {
    document.querySelectorAll('.investments-block').forEach( ( block ) => {
        const input     = block.querySelector( '[data-investments-search]' );
        const table     = block.querySelector( '[data-investments-table]' );
        const countEl   = block.querySelector( '[data-investments-count]' );
        const noResults = block.querySelector( '.investments-block__no-results' );

        if ( ! input || ! table ) return;

        const thead = table.querySelector( 'thead' );
        const rows = Array.from( table.querySelectorAll( 'tbody tr' ) );
        const total = rows.length;
        const minChars = 2;

        const setCountText = ( visible, canSearch ) => {
            if ( ! countEl ) return;
            countEl.textContent = canSearch
                ? `${visible} of ${total} available funds`
                : `${total} available funds`;
        };

        const renderState = ( query ) => {
            const canSearch = query.length >= minChars;
            let visible = 0;

            // Add background color to alternate visible rows
            rows.forEach( ( row ) => {
                const match = canSearch && row.textContent.toLowerCase().includes( query );
                row.hidden = ! match;
                row.classList.remove( 'is-even-visible' );

                if ( match ) {
                    visible++;
                    if ( visible % 2 === 0 ) {
                        row.classList.add( 'is-even-visible' );
                    }
                }
            } );

            const hasVisibleRows = visible > 0;
            table.hidden = ! canSearch || ! hasVisibleRows;
            if ( thead ) thead.hidden = ! canSearch || ! hasVisibleRows;
            if ( noResults ) noResults.hidden = ! canSearch || hasVisibleRows;

            setCountText( visible, canSearch );
        };

        // Hide all rows and header initially — only show on search
        renderState( '' );

        let debounceTimer;

        input.addEventListener( 'input', () => {
            clearTimeout( debounceTimer );
            debounceTimer = setTimeout( () => {
                const query = input.value.trim().toLowerCase();
                renderState( query );
            }, 200 );
        } );
    } );
}
